import { backgroundOrange, orange } from '@/theme/colors'
import styled from 'styled-components'

export const FilesPageContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background-color: ${backgroundOrange};
	overflow-y: auto;
`

export const FilesContent = styled.div`
	padding: 2rem 1.5rem;
	max-width: 1400px;
	margin: 0 auto;
	width: 100%;

	@media (max-width: 600px) {
		padding: 1rem 0.875rem;
	}
`

export const FilesHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.5rem;
	gap: 1rem;
	flex-wrap: wrap;

	@media (max-width: 600px) {
		margin-bottom: 1rem;
		gap: 0.75rem;
	}
`

export const FilesTitle = styled.h2`
	margin: 0;
	font-size: 1.5rem;
	font-weight: 600;
	color: #2c3e50;

	@media (max-width: 600px) {
		font-size: 1.25rem;
	}
`

export const UploadButton = styled.button`
	background: ${orange};
	color: white;
	border: none;
	padding: 0.625rem 1.25rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover:not(:disabled) {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

export const FileGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 1rem;

	@media (max-width: 600px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 0.75rem;
	}

	@media (min-width: 768px) {
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	}

	@media (min-width: 1200px) {
		grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	}
`

export const FileCard = styled.div`
	background: white;
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
	cursor: pointer;
	transition: all 0.2s ease;
	position: relative;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		transform: translateY(-2px);
	}
`

export const FileThumbnail = styled.div`
	width: 100%;
	aspect-ratio: 1;
	overflow: hidden;
	background: #f3f4f6;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const FileTypeIcon = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	color: #9ca3af;

	span {
		font-size: 0.75rem;
		font-weight: 600;
		text-transform: uppercase;
		color: #6b7280;
	}
`

export const FileInfo = styled.div`
	padding: 0.625rem 0.75rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
`

export const FileName = styled.div`
	font-size: 0.8rem;
	font-weight: 500;
	color: #374151;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex: 1;
	min-width: 0;
`

export const DeleteFileButton = styled.button`
	background: transparent;
	border: none;
	color: #9ca3af;
	padding: 4px;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: color 0.2s;
	flex-shrink: 0;

	&:hover {
		color: #dc2626;
	}
`

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 4rem 2rem;
	text-align: center;
	color: #6b7280;
	gap: 1rem;

	p {
		margin: 0;
		font-size: 1rem;
	}

	span {
		font-size: 0.875rem;
		color: #9ca3af;
	}
`

export const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	font-size: 18px;
	color: #6b7280;
`

export const ErrorContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	font-size: 18px;
	color: #dc2626;
`

export const UploadOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: 999;
	gap: 1rem;
	color: white;
	backdrop-filter: blur(2px);
`

export const UploadSpinner = styled.div`
	width: 48px;
	height: 48px;
	border: 4px solid rgba(255, 255, 255, 0.3);
	border-top-color: white;
	border-radius: 50%;
	animation: spin 0.8s linear infinite;

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`

export const UploadText = styled.div`
	font-size: 1.125rem;
	font-weight: 500;
`

// Image Viewer Modal
export const ViewerBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.9);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1001;
	padding: 2rem;

	@media (max-width: 600px) {
		padding: 1rem;
	}
`

export const ViewerContainer = styled.div`
	position: relative;
	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;

	img {
		max-width: 90vw;
		max-height: 80vh;
		object-fit: contain;
		border-radius: 8px;
	}
`

export const ViewerControls = styled.div`
	display: flex;
	gap: 0.75rem;
`

export const ViewerButton = styled.button`
	background: rgba(255, 255, 255, 0.15);
	color: white;
	border: none;
	padding: 0.5rem 1rem;
	border-radius: 6px;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.2s;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: rgba(255, 255, 255, 0.25);
	}
`

export const ViewerCloseButton = styled.button`
	position: absolute;
	top: -2.5rem;
	right: -1rem;
	background: transparent;
	border: none;
	color: white;
	font-size: 2rem;
	cursor: pointer;
	padding: 0.25rem;
	line-height: 1;

	&:hover {
		opacity: 0.7;
	}

	@media (max-width: 600px) {
		top: -2rem;
		right: 0;
	}
`

export const HiddenFileInput = styled.input`
	display: none;
`
